<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div>
            <router-link to="/actions"><h3 class="card-title"><i class="ti-check-box"></i> {{ $t('My Actions') }}</h3></router-link>
          </div>
          <div class="ml-auto">
            <button type="button" class="btn btn-sm btn-rounded btn-info" @click="showModal = !showModal"><i class="ti-plus"></i> {{ $t('Add action') }}</button>
          </div>
        </div>
        <div class="table-responsive m-t-20">
          <table class="table no-th-brd pro-of-month" v-show="actionData.length > 0">
            <tbody>
            <tr v-for="action in actionData">
              <td>
                <h2>
                  <i v-if="action.status === 'accept'" class="ti-settings text-info"></i>
                  <i v-else-if="action.status === 'done'" class="ti-check text-success"></i>
                  <i v-else-if="action.status === 'declined'" class="ti-close text-danger"></i>
                  <i v-else class="ti-more-alt text-info"></i>
                </h2>
              </td>
              <td>
                <router-link :to="'/action/' + action.uid"><h5 class="font-bold" v-html="action.title"></h5>
                <small class="text-muted">{{ $t(action.status) |  ucFirst }}</small></router-link>
              </td>
              <td>
                  <button type="button" @click="processUpdate(action.uid)" v-if="action.status === 'accept'" class="btn btn-rounded btn-outline-secondary btn-sm" >{{ $t('Accept') }}</button>
              </td>
              <td>
                <router-link :to="'/action/' + action.uid">
                  {{ $t("Details") }}
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
          <h3 class="text-muted" v-show="actionData.length < 1">
            {{ $t("You have no actions scheduled.")}}
          </h3>
          <span class="text-info">
            <i class="ti-plus"></i> <router-link to="Actions">{{ $t('All actions') }}</router-link>
          </span>
        </div>
      </div>
    </div>


    <!-- Modal -->
    <add-action-modal v-if="showModal"></add-action-modal>
  </div>
</template>

<script>
  import apiHelper from '../mixins/APIHelper';
  import AddActionModal from './AddActionModal';

    export default {
      props: {
        "data": {
          default: null,
          type: Array
        }
      },
      components: {
        "add-action-modal": AddActionModal
      },
      name: "actions-widget",
      data: function () {
        return {
          actionData: this.data,
          showModal: false,
          meetingId: ""
        }
      },
      created() {
        let vm = this;
        this.meetingId = typeof this.$parent.meetingID === 'undefined' ? "" : this.$parent.meetingID;
        if (this.actionData === null) {
          this.getActions();
        }
        this.$on('close', function (data) {
          this.getActions();
          vm.showModal = false;
        });
      },
      methods: {
        // Function to get the action data from the server
        getActions: function() {
          let vm = this;
          let data_to_send = {
            limit: 4,
            history: 0
          };
          apiHelper.getResource('/api/user/{uid}/actions', data_to_send).then((data) => {
            vm.actionData = data;
          })
        },
        // Function to accept the action and regrab the actions.
        processUpdate: function (action_uid) {
          let vm = this;
          let uid = action_uid;
          let data = {status: "pending"};

          apiHelper.patchResource("/api/action/" + uid, data)
            .then(function () {
              vm.getActions();
            })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ActionsWidget.vue